import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, brl, formatDateTime } from "../../lib/api";
import { CheckCircle, XCircle } from "@phosphor-icons/react";

export default function VerifyPromissory() {
  const { promissoryId } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      try { setData((await api.get(`/public/promissories/${promissoryId}/verify`)).data); }
      catch { setData({ valid: false }); }
    })();
  }, [promissoryId]);

  if (!data) return <div className="min-h-screen grid place-items-center text-sm tracking-widest uppercase text-[#5C5A57]">Verificando...</div>;

  return (
    <div className="min-h-screen bg-[#F5F0EB] grid place-items-center p-6">
      <div className="bg-white border border-[#EBE5DF] max-w-lg w-full p-10">
        <div className="text-center">
          {data.valid ? (
            <>
              <CheckCircle size={48} weight="duotone" color="#7B9D7E" className="mx-auto mb-3" />
              <h1 className="font-display text-3xl font-bold tracking-tight">Promissoria valida</h1>
              <p className="text-sm text-[#5C5A57] mt-2">N. {data.promissory.number} · Cris Lingerie</p>
            </>
          ) : (
            <>
              <XCircle size={48} weight="duotone" color="#8B5E5E" className="mx-auto mb-3" />
              <h1 className="font-display text-3xl font-bold tracking-tight">Documento nao encontrado</h1>
            </>
          )}
        </div>
        {data.valid && (
          <div className="mt-6 space-y-2 text-sm">
            <div className="flex justify-between border-b border-[#EBE5DF] py-2"><span className="text-[#5C5A57]">Cliente</span><span>{data.promissory.client_name}</span></div>
            <div className="flex justify-between border-b border-[#EBE5DF] py-2"><span className="text-[#5C5A57]">Valor</span><span className="tabular font-medium">{brl(data.promissory.total)}</span></div>
            <div className="flex justify-between border-b border-[#EBE5DF] py-2"><span className="text-[#5C5A57]">Emitida</span><span>{formatDateTime(data.promissory.issued_at)}</span></div>
            <div className="flex justify-between border-b border-[#EBE5DF] py-2"><span className="text-[#5C5A57]">Hash</span><span className="tabular text-xs">{data.promissory.acceptance_hash?.slice(0, 16)}...</span></div>
          </div>
        )}
      </div>
    </div>
  );
}
